import type { GameState } from "../game/GameState";
import type { QuestSnapshot } from "../quest/QuestState";
import { WEAPON_CONFIGS } from "../weapons/Weapon";
import { createElement } from "./dom";

export class Hud {
  public readonly element = createElement("section", "hud hidden");
  private readonly health = createElement("span");
  private readonly armor = createElement("span");
  private readonly ammo = createElement("span");
  private readonly weapon = createElement("span");
  private readonly message = createElement("div", "hud-message");
  private readonly prompt = createElement("div", "use-prompt");
  private readonly damage = createElement("div", "damage-flash");
  private readonly muzzle = createElement("div", "muzzle-flash");
  public readonly weaponCanvas = createElement("canvas", "weapon-canvas");
  private messageTimeout = 0;

  public constructor() {
    const left = createElement("div", "hud-cluster vitals");
    left.append(this.readout("ЗДОРОВЬЕ", this.health), this.readout("БРОНЯ", this.armor));
    const centre = createElement("div", "reticle", "+");
    const right = createElement("div", "hud-cluster tactical");
    right.append(this.readout("ОРУЖИЕ", this.weapon), this.readout("БОЕЗАПАС", this.ammo));
    this.weaponCanvas.width = 320;
    this.weaponCanvas.height = 220;
    this.element.append(
      left,
      centre,
      right,
      this.weaponCanvas,
      this.message,
      this.prompt,
      this.damage,
      this.muzzle,
    );
  }

  public update(state: GameState, deltaSeconds: number): void {
    const currentAmmo = state.ammo[state.selectedWeapon];
    this.health.textContent = state.health.toString().padStart(3, "0");
    this.armor.textContent = state.armor.toString().padStart(3, "0");
    this.weapon.textContent = WEAPON_CONFIGS[state.selectedWeapon].displayName;
    this.ammo.textContent = `${currentAmmo.magazine.toString().padStart(2, "0")} / ${currentAmmo.reserve.toString().padStart(3, "0")}`;
    this.element.classList.toggle("critical", state.health <= 25);
    this.element.style.setProperty("--health", `${state.health}%`);
    if (this.messageTimeout > 0) {
      this.messageTimeout -= deltaSeconds;
      if (this.messageTimeout <= 0) {
        this.message.textContent = "";
      }
    }
  }

  public showMessage(text: string, seconds = 2.4): void {
    this.message.textContent = text.toUpperCase();
    this.messageTimeout = seconds;
  }

  public setPrompt(text: string | undefined): void {
    this.prompt.textContent = text ?? "";
    this.prompt.classList.toggle("visible", Boolean(text));
  }

  /** Compatibility for archived mission code, which is no longer reachable from the game. */
  public setMissionStatus(
    _snapshot: QuestSnapshot,
    _bossHealth: number,
    _bossMaximumHealth: number,
    _bossPhase: number,
  ): void {}

  public flashDamage(): void {
    this.damage.classList.remove("active");
    void this.damage.offsetWidth;
    this.damage.classList.add("active");
  }

  public flashMuzzle(): void {
    this.muzzle.classList.remove("active");
    void this.muzzle.offsetWidth;
    this.muzzle.classList.add("active");
  }

  public show(): void {
    this.element.classList.remove("hidden");
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }

  private readout(label: string, value: HTMLElement): HTMLElement {
    const container = createElement("div", "hud-readout");
    container.append(createElement("small", undefined, label), value);
    return container;
  }
}
